import { DEFAULT_STATE } from '../constants'

export const initialFiltersState = {
  libraryFilter: DEFAULT_STATE.libraryFilter,
}
